import React, { useEffect } from 'react';

import ChangeLogItem from './ChangeLogItem';
import useData from '../../utilities/useData';

const ChangeLogList = ({ customerId }) => {
    const getUrl = `/api/changelogs/list?customerId=${customerId}`;
    const { data, fetchData, isLoaded } = useData(getUrl);

    useEffect(() => {
        window.addEventListener('updateChangeLog', fetchData);

        // cleanup this component
        return () => {
            window.removeEventListener('updateChangeLog', fetchData);
        };
    }, []);

    const listItems = isLoaded && data.items && data.items.map((item, idx) =>
        <ChangeLogItem
            item={item}
            key={idx}
        />);

    return (
        <table style={{ width: '100%', borderBottom: 'none' }}>
            <tbody>
                {listItems}
            </tbody>
        </table>
    );
}

export default ChangeLogList;